const specialities = [
    {id: 'RECEPTIONIST', name: 'Реєстратор'},
    {id: 'PHARMACIST', name: 'Фармація'},
    {id: 'PROVISOR', name: 'Загальна фармація'},
    {id: 'CLINICAL_PROVISOR', name: 'Клінічна фармація'}

    // {id: 'PHYSICAL_THERAPY_AND_SPORTS_MEDICINE', name: 'Лікувальна фізкультура і спортивна медицина'},
    // {id: 'VIROLOGY', name: 'Вірусологія'},
    // {id: 'INFECTIOUS_DISEASES', name: 'Інфекційні хвороби'},
    // {id: 'TRADITIONAL_ALTERNATIVE_MEDICINE', name: 'Народна та нетрадиційна медицина'},
    // {id: 'FORENSIC_MEDICAL_TOXICOLOGY', name: 'Судово-медична токсикологія'},
    // {id: 'PEDIATRIC_HEMATOLOGY', name: 'Дитяча гематологія'},
    // {id: 'OCCUPATIONAL_MEDICINE', name: 'Гігієна праці'},
    // {id: 'PEDIATRIC_ALLERGY', name: 'Дитяча алергологія'},
    // {id: 'GENERAL_HEMATOLOGY', name: 'Гематологія'},
    // {id: 'MEDICAL_CASE_EMERGENCY_MEDICINE', name: 'Лікувальна справа (невідкладні стани)'},
    // {id: 'LABORATORY_IMMUNOLOGY', name: 'Лабораторна імунологія'},
    // {id: 'MEDICAL_STATISTICS', name: 'Медична статистика'},
    // {id: 'PROCTOLOGY', name: 'Проктологія'},
    // {id: 'OPHTHALMOLOGY', name: 'Офтальмологія'},
    // {id: 'SURGICAL_ONCOLOGY', name: 'Онкохірургія'},
    // {id: 'COMMON_HYGIENE', name: 'Загальна гігієна'},
    // {id: 'MEDICAL_GENETICS', name: 'Генетика медична'},
    // {id: 'PEDIATRIC_ONCOLOGY', name: 'Дитяча онкологія'},
    // {id: 'RADIOLOGIC_DIAGNOSIS', name: 'Радіонуклідна діагностика'},
    // {id: 'PHARMACEUTICS_ORGANIZATION', name: 'Організація і управління фармацією'},
    // {id: 'FORENSIC_MEDICAL_EXAMINATION', name: 'Судово-медична експертиза'},
    // {id: 'RADIATION_THERAPY', name: 'Променева терапія'},
    // {id: 'PHYSIOTHERAPY', name: 'Фізіотерапія'},
    // {id: 'PEDIATRIC_UROLOGY', name: 'Дитяча урологія'},
    // {id: 'SPORTS_MEDICINE', name: 'Спортивна медицина'},
    // {id: 'RHEUMATOLOGY', name: 'Ревматологія'},
    // {id: 'TOXICOLOGY', name: 'Токсикологія'},
    // {id: 'ANALYTICAL_AND_CONTROL_PHARMACY', name: 'Аналітично-контрольна фармація'},
    // {id: 'PEDIATRIC_ORTHOPAEDICS', name: 'Дитяча ортопедія і травматологія'},
    // {id: 'PEDIATRIC_NEUROLOGY', name: 'Дитяча неврологія'},
    // {id: 'PEDIATRIC_GYNECOLOGY', name: 'Дитяча гінекологія'},
    // {id: 'ORTHOPAEDICS', name: 'Ортопедія і травматологія'},
    // {id: 'PEDIATRICIAN', name: 'Педіатрія'},
    // {id: 'PATHOLOGY_LABORATORY', name: 'Лабораторна справа (патологія)'},
    // {id: 'RADIATION_HYGIENE', name: 'Радіаційна гігієна'},
    // {id: 'IMMUNOLOGY', name: 'Імунологія'},
    // {id: 'DIETETICS', name: 'Дієтологія'},
    // {id: 'REFLEXOLOGY', name: 'Рефлексотерапія'},
    // {id: 'PEDIATRIC_ENDOCRINOLOGY', name: 'Дитяча ендокринологія'},
    // {id: 'EPIDEMIOLOGY', name: 'Епідеміологія'},
    // {id: 'FORENSIC_PSYCHIATRIC_EXAMINATION', name: 'Судово-психіатрична експертиза'},
    // {id: 'CLINICAL_DIAGNOSTIC', name: 'Клінічна лабораторна діагностика'},
    // {id: 'FAMILY_DOCTOR', name: 'Загальна практика - сімейна медицина'},
    // {id: 'PEDIATRIC_OPHTHALMOLOGY', name: 'Дитяча офтальмологія'},
    // {id: 'PHTHISIOLOGY', name: 'Фтизіатрія'},
    // {id: 'OBSTETRICS', name: 'Акушерська справа'},
    // {id: 'PATHOLOGIC_ANATOMY', name: 'Патологічна анатомія'},
    // {id: 'SANOLOGY', name: 'Санологія'},
    // {id: 'FORENSIC_MEDICINE', name: 'Суднова медицина'},
    // {id: 'PHYSICAL_THERAPY', name: 'Лікувальна фізкультура'},
    // {id: 'NEPHROLOGY', name: 'Нефрологія'},
    // {id: 'ORTHODONTOLOGY', name: 'Ортодонтія'},
    // {id: 'COMMUNAL_HYGIENE', name: 'Комунальна гігієна'},
    // {id: 'NURSING', name: 'Сестринська справа'},
    // {id: 'THERAPIST', name: 'Терапія'},
    // {id: 'CLINICAL_IMMUNOLOGY', name: 'Клінічна імунологія'},
    // {id: 'LABORATORY_RESEARCH_OF_ENVIRONMENTAL_FACTORS', name: 'Лабораторні дослідження факторів навколишнього середовища'},
    // {id: 'DERMATO-VENEREOLOGY', name: 'Дерматовенерологія'},
    // {id: 'PEDIATRIC_IMMUNOLOGY', name: 'Дитяча імунологія'},
    // {id: 'GASTROENTEROLOGY', name: 'Гастроентерологія'},
    // {id: 'NEONATOLOGY', name: 'Неонатологія'},
    // {id: 'PEDIATRIC_GASTROENTEROLOGY', name: 'Дитяча гастроентерологія'},
    // {id: 'CARDIOVASCULAR_SURGERY', name: 'Хірургія серця та магістральних судин'},
    // {id: 'COMBUSTIOLOGY', name: 'Комбустіологія'},
    // {id: 'PARASITOLOGY', name: 'Паразитологія'},
    // {id: 'OBSTETRICS_AND_GYNECOLOGY', name: 'Акушерство і гінекологія'},
    // {id: 'ORTHOPEDIC_DENTISTRY', name: 'Ортопедична стоматологія'},
    // {id: 'PHYSICAL_MEDICINE_AND_REHABILITATION', name: 'Фізична та реабілітаційна медицина'},
    // {id: 'ERGOTHERAPEUTICS', name: 'Ерготерапія'},
    // {id: 'PUBLIC_HEALTH_AND_PREVENTIVE_MEDICINE', name: 'Медико-профілактична справа'},
    // {id: 'FORENSIC_MEDICAL_HISTOLOGY', name: 'Судово-медична гістологія'},
    // {id: 'GENERAL_SURGERY', name: 'Хірургія'},
    // {id: 'PEDIATRIC_PSYCHIATRY', name: 'Дитяча психіатрія'},
    // {id: 'PHYSICAL_THERAPEUTICS', name: 'Фізична терапія'},
    // {id: 'RADIOLOGY', name: 'Радіологія'},
    // {id: 'PEDIATRIC_DERMATO-VENEREOLOGY', name: 'Дитяча дерматовенерологія'},
    // {id: 'PEDIATRIC_PATHOLOGY', name: 'Дитяча патологічна анатомія'},
    // {id: 'NEUROSURGERY', name: 'Нейрохірургія'},
    //
    // {id: 'PEDIATRIC_INFECTIOUS_DISEASE', name: 'Дитячі інфекційні хвороби'},
    // {id: 'ANAESTHETICS', name: 'Анестезіологія'},
    // {id: 'CLINICAL_LABORATORY', name: 'Лабораторна справа (клініка)'},
    // {id: 'SEXOPATHOLOGY', name: 'Сексопатологія'},
    // {id: 'PULMONOLOGY', name: 'Пульмонологія'},
    // {id: 'PEDIATRIC_PULMONOLOGY', name: 'Дитяча пульмонологія'},
    // {id: 'PSYCHOTHERAPY', name: 'Психотерапія'},
    // {id: 'MICROBIOLOGY', name: 'Мікробіологія і вірусологія'},
    // {id: 'DISINFECTION', name: 'Дезінфекційна справа'},
    // {id: 'ENDOCRINOLOGY', name: 'Ендокринологія'},
    // {id: 'BACTERIOLOGY', name: 'Бактеріологія'},
    // {id: 'PSYCHIATRY', name: 'Психіатрія'},
    // {id: 'THERAPEUTIC_DENTISTRY', name: 'Терапевтична стоматологія'},
    // {id: 'PSYCHOPHYSIOLOGY', name: 'Психофізіологія'},
    // {id: 'CARDIOLOGY', name: 'Кардіологія'},
    // {id: 'FUNCTIONAL_DIAGNOSTICS', name: 'Функціональна діагностика'},
    // {id: 'PEDIATRIC_PHTHISIOLOGY', name: 'Дитяча фтизіатрія'},
    // {id: 'PEDIATRIC_OTOLARYNGOLOGY', name: 'Дитяча отоларингологія'},
    // {id: 'PUBLIC_HEALTH_ORGANIZATION', name: 'Організація і управління охороною здоров\'я'},
    // {id: 'NARCOLOGY', name: 'Наркологія'},
    // {id: 'LABORATORY_RESEARCH_OF_ENVIRONMENT_CHEMICAL_FACTORS', name: 'Лабораторні дослідження хімічних факторів навколишнього середовища'},
    // {id: 'PEDIATRIC_NEPHROLOGY', name: 'Дитяча нефрологія'},
    // {id: 'STOMATOLOGY', name: 'Стоматологія'},
    // {id: 'ONCOTOLARYNGOLOGY', name: 'Онкоотоларингологія'},
    // {id: 'LABORATORY_GENETICS', name: 'Генетика лабораторна'},
    // {id: 'ONCOLOGY', name: 'Онкологія'},
    // {id: 'PEDIATRIC_ANAESTHETICS', name: 'Дитяча анестезіологія'},
    // {id: 'EMERGENCY_MEDICINE', name: 'Медицина невідкладних станів'},
    // {id: 'ALLERGOLOGY', name: 'Алергологія'},
    // {id: 'UROLOGY', name: 'Урологія'},
    // {id: 'ADOLESCENT_MEDICINE', name: 'Підліткова терапія'},
    // {id: 'FOOD_HYGIENE', name: 'Гігієна харчування'},
    // {id: 'GERIATRICS', name: 'Геріатрія'},
    // {id: 'ENDOSCOPY', name: 'Ендоскопія'},
    // {id: 'AEROSPACE_MEDICINE', name: 'Авіаційна та космічна медицина'},
    // {id: 'PEDIATRIC_HYGIENE', name: 'Гігієна дітей та підлітків'},
    // {id: 'OCCUPATIONAL_PATHOLOGY', name: 'Професійна патологія'},
    // {id: 'PEDIATRIC_CARDIOLOGY', name: 'Дитяча кардіоревматологія'},
    // {id: 'CLINICAL_BIOCHEMISTRY', name: 'Клінічна біохімія'},
    // {id: 'THORACIC_SURGERY', name: 'Торакальна хірургія'},
    // {id: 'GENERAL_MEDICINE', name: 'Лікувальна справа'},
    // {id: 'LABORATORY_RESEARCH_OF_ENVIRONMENT_PHYSICAL_FACTORS', name: 'Лабораторні дослідження фізичних факторів навколишнього середовища'},
    // {id: 'X_RAY_RADIOLOGY', name: 'Рентгенологія'},
    // {id: 'FORENSIC_IMMUNOLOGY', name: 'Судово-медична імунологія'},
    // {id: 'FORENSIC_CRIMINOLOGY', name: 'Судово-медична криміналістика'},
    // {id: 'FORENSIC_CYTOLOGY', name: 'Судово-медична цитологія'},
    // {id: 'TRANSFUSIOLOGY', name: 'Трансфузіологія'},
    // {id: 'NEUROLOGY', name: 'Неврологія'},
    // {id: 'SURGICAL_DENTISTRY', name: 'Хірургічна стоматологія'},
    // {id: 'HYGIENE_LABORATORY', name: 'Лабораторна справа (гігієна)'},
    // {id: 'TRANSPLANTOLOGY', name: 'Трансплантологія'},
    // {id: 'GYNECOLOGIC_ONCOLOGY', name: 'Онкогінекологія'},
    // {id: 'PEDIATRIC_STOMATOLOGY', name: 'Дитяча стоматологія'},
    // {id: 'MEDICAL_PSYCHOLOGY', name: 'Медична психологія'},
    // {id: 'VASCULAR_SURGERY', name: 'Судинна хірургія'},
    // {id: 'OPERATING_NURSING', name: 'Сестринська справа (операційна)'},
    // {id: 'OTORHINOLARYNGOLOGY', name: 'Отоларингологія'},
    // {id: 'PEDIATRIC_SURGERY', name: 'Дитяча хірургія'},
    // {id: 'AUDIOLOGY', name: 'Сурдологія'},
    // {id: 'ULTRASONIC_DIAGNOSIS', name: 'Ультразвукова діагностика'}
];

export default specialities;
